import { Controller } from "@hotwired/stimulus"
import { Offcanvas } from "bootstrap"

export const DRAWER_ID = "people-quick-action-drawer"
export const FRAME_ID = "people_quick_action"

// Panneau latéral des actions rapides People : créé à la demande dans <body>, permanent pour Turbo,
// son contenu est une Turbo Frame chargée depuis l'URL de l'action.
export function quickActionDrawer() {
  let drawer = document.getElementById(DRAWER_ID)
  if (!drawer) {
    drawer = document.createElement("div")
    drawer.id = DRAWER_ID
    drawer.className = "offcanvas offcanvas-end people-quick-drawer"
    drawer.tabIndex = -1
    // Survit aux visites Turbo et au rafraîchissement en morph qui suit une création.
    drawer.setAttribute("data-turbo-permanent", "")
    drawer.setAttribute("aria-label", "Action rapide")
    drawer.innerHTML = `<turbo-frame id="${FRAME_ID}" class="people-quick-panel"><div class="people-quick-panel__loading"><span class="spinner-border text-primary" role="status"></span></div></turbo-frame>`
    document.body.appendChild(drawer)
  }
  return drawer
}

export default class extends Controller {
  open(event) {
    event.preventDefault()
    const drawer = quickActionDrawer()
    const frame = drawer.querySelector(`turbo-frame#${FRAME_ID}`)
    const url = event.currentTarget.dataset.url
    if (frame.getAttribute("src") === url) frame.reload()
    else frame.src = url
    Offcanvas.getOrCreateInstance(drawer).show()
  }
}
